/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_FailedInputs */

const en_mobile_upload_failed = /** @type {(inputs: Mobile_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed`)
};

const es_mobile_upload_failed = /** @type {(inputs: Mobile_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo subir`)
};

/**
* | output |
* | --- |
* | "Upload failed" |
*
* @param {Mobile_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_failed = /** @type {((inputs?: Mobile_Upload_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_failed(inputs)
	return en_mobile_upload_failed(inputs)
});